import { render, staticRenderFns } from "./BrandLogo.vue?vue&type=template&id=a534fa1c&scoped=true"
import script from "./BrandLogo.vue?vue&type=script&lang=js"
export * from "./BrandLogo.vue?vue&type=script&lang=js"
import style0 from "./BrandLogo.vue?vue&type=style&index=0&id=a534fa1c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a534fa1c",
  null
  
)

export default component.exports